import React, { useState } from 'react';
import { useLang } from '../../i18n/LanguageContext';
import { waLink } from '../../data/contact';

const MEMBERS = ['mSelf', 'mSpouse', 'mSon', 'mDaughter', 'mFather', 'mMother'];
const VEHICLES = ['vCar', 'vBike', 'vComm'];

const chipCls = (on, tone) => `block text-center text-sm font-semibold border rounded-xl py-2.5 cursor-pointer transition select-none ${on ? `${tone.solid} text-white border-transparent` : 'border-slate-200 hover:border-slate-400'}`;

// Form-first hero card. Answers go to Kalyani on WhatsApp; nothing is stored by the website.
export default function LeadForm({ product }) {
  const { lang, t } = useLang();
  const tone = product.tone;
  const [members, setMembers] = useState(['mSelf', 'mSpouse']);
  const [age, setAge] = useState(35);
  const [income, setIncome] = useState('');
  const [vehicle, setVehicle] = useState('vCar');
  const [year, setYear] = useState('');
  const [note, setNote] = useState('');

  const toggle = (k) => setMembers((m) => (m.includes(k) ? m.filter((x) => x !== k) : [...m, k]));

  const details = () => {
    if (product.form === 'family') return `${t('fWho')} ${members.map(t).join(', ') || '-'}. ${t('fEldest')}: ${age}.`;
    if (product.form === 'life') return `${t('fAge')}: ${age}. ${t('fIncome')}: ${income || '-'}.`;
    if (product.form === 'vehicle') return `${t('vType')}: ${t(vehicle)}. ${t('vYear')}: ${year || '-'}.`;
    return note || '';
  };

  const submit = (e) => {
    e.preventDefault();
    window.open(waLink(t('waLead')(product[lang].title, details())), '_blank', 'noopener');
  };

  return (
    <form onSubmit={submit} className={`bg-white rounded-3xl shadow-2xl shadow-ink/10 p-6 sm:p-8 border ${tone.ring}`}>
      {product.form === 'family' && (
        <>
          <h2 className="text-xl font-extrabold">{t('fWho')}</h2>
          <div className="mt-4 grid grid-cols-3 gap-2">
            {MEMBERS.map((k) => (
              <button key={k} type="button" aria-pressed={members.includes(k)} onClick={() => toggle(k)} className={chipCls(members.includes(k), tone)}>{t(k)}</button>
            ))}
          </div>
          <label className="block mt-5 text-sm font-semibold">{t('fEldest')}
            <input type="number" min="18" max="99" value={age} onChange={(e) => setAge(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3" /></label>
        </>
      )}
      {product.form === 'life' && (
        <>
          <h2 className="text-xl font-extrabold">{t('fAboutYou')}</h2>
          <label className="block mt-4 text-sm font-semibold">{t('fAge')}
            <input type="number" min="18" max="70" value={age} onChange={(e) => setAge(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3" /></label>
          <label className="block mt-4 text-sm font-semibold">{t('fIncome')}
            <select value={income} onChange={(e) => setIncome(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 bg-white">
              <option value="">{t('fChoose')}</option>
              {['< ₹25,000', '₹25,000 – ₹50,000', '₹50,000 – ₹1,00,000', '> ₹1,00,000'].map((o) => <option key={o}>{o}</option>)}
            </select></label>
        </>
      )}
      {product.form === 'vehicle' && (
        <>
          <h2 className="text-xl font-extrabold">{t('vType')}</h2>
          <div className="mt-4 grid grid-cols-3 gap-2">
            {VEHICLES.map((k) => <button key={k} type="button" aria-pressed={vehicle === k} onClick={() => setVehicle(k)} className={chipCls(vehicle === k, tone)}>{t(k)}</button>)}
          </div>
          <label className="block mt-5 text-sm font-semibold">{t('vYear')}
            <input type="number" min="1990" max="2030" placeholder="2021" value={year} onChange={(e) => setYear(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3" /></label>
        </>
      )}
      {product.form === 'simple' && (
        <>
          <h2 className="text-xl font-extrabold">{t('sNeed')}</h2>
          <textarea rows="4" value={note} onChange={(e) => setNote(e.target.value)} placeholder={t('sNeedPh')} className="mt-4 w-full rounded-xl border border-slate-200 px-4 py-3" />
        </>
      )}
      <button type="submit" className={`mt-6 w-full text-white font-bold py-3.5 rounded-xl transition ${tone.solid}`}>💬 {t('fCtaWa')}</button>
      <p className="mt-3 text-[11px] text-slate-400 text-center">🔒 {t('fPriv2')}</p>
    </form>
  );
}
